import styled from 'styled-components';

export const ExploreTools = styled.div`
  max-width: 991px;
  margin: 1.5em auto 0 auto;
`;
export const ToolContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 0;
  }
`;
export const ToolImage = styled.img`
  text-align: center;
  width: 180px;
  height: 180px;
  padding: 37px 37px;
  @media (max-width: 720px) {
    width: 140px;
    height: 140px;
  }
`;
export const ToolName = styled.div`
  text-align: center;
  color: #000;
  padding-top: 10px;
  font-size: 15px;
  font-weight: bold;
  opacity: 0.7;
  padding-bottom: 10px;
`;
export const ToolWrapper = styled.div`
  width: 180px;
  height: 180px;
  border-radius: 48px;
  box-shadow: 0 4px 6px 0 rgb(0 0 0 / 10%);
  background-color: #fcfcfc;
  margin-bottom: 75px;
  cursor: pointer;
  @media (max-width: 720px) {
    width: 140px;
    height: 140px;
  }
`;
export const Banner = styled.div`
  background-color: #d0effa;
  position: relative;
  height: 250px;
  margin: 2em 10em;

  @media (max-width: 720px) {
    margin: 0;
    height: 145px;
  }
`;
export const BannerWrapper = styled.div`
  text-align: center;
  padding-top: 50px;
  @media (max-width: 720px) {
    padding-top: 35px;
  }
`;

export const BannerText = styled.div`
  font-size: clamp(2rem, 4vw, 3.5rem);
  font-weight: bold;
  color: #6e6e6e;
`;
export const BannerSubtext = styled.div`
  font-size: clamp(14px, 4vw, 18px);
  color: #6e6e6e;
`;
export const BannerPara = styled.div`
  text-align: center;
  padding: 20px 40px;
  margin: 2em 10em;
  @media (max-width: 720px) {
    margin: 0;
    padding: 15px;
    font-size: 14px;
  }
`;
